var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.809 7.753L17.293.27l1.414 1.414-7.484 7.484 7.484 7.484-1.414 1.415-7.484-7.484-7.484 7.484L.91 16.65l7.484-7.484L.91 1.683 2.325.27l7.484 7.484z",
    fill: "#000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik05LjgwODkxIDcuNzUzMUwxNy4yOTMgMC4yNjkwNDNMMTguNzA3MiAxLjY4MzI2TDExLjIyMzEgOS4xNjczMUwxOC43MDcyIDE2LjY1MTRMMTcuMjkzIDE4LjA2NTZMOS44MDg5MSAxMC41ODE1TDIuMzI0ODYgMTguMDY1NkwwLjkxMDY0NSAxNi42NTE0TDguMzk0NyA5LjE2NzMxTDAuOTEwNjQ2IDEuNjgzMjZMMi4zMjQ4NiAwLjI2OTA0M0w5LjgwODkxIDcuNzUzMVoiCiAgICBmaWxsPSJibGFjayIgLz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };